// Abu Dhabi AC service hub. Not in the aircon hreflang set (Dubai is en-AE);
// it stands on its own Abu Dhabi-specific content.
const content = {
    title: (c) => `AC Service Abu Dhabi from ${c.money(c.tables.general[0].wall)} | Villas & Apartments`,
    description: (c) =>
        `AC service in Abu Dhabi: cleaning from ${c.money(c.tables.general[0].wall)}, coil wash from ${c.money(c.tables.chemicalWash[0].wall)}, gas refills and repairs for villas and island apartments.`,
    eyebrow: 'Abu Dhabi',
    h1: 'AC Service in Abu Dhabi',
    lead: (c) =>
        `From island towers on Reem and Yas to family villas in Khalifa City and MBZ, we clean, wash, refill and repair split, ducted and cassette units across Abu Dhabi. One split unit starts at ${c.money(c.tables.general[0].wall)}.`,
    image: 'blog/living/aircon/repairman-doing-air-conditioner-service-1920-1080.jpg',
    imageAlt: 'AC technician servicing a wall-mounted unit in an Abu Dhabi home',
    facts: ['Villas with many units', 'Island and mainland', 'Prices in AED, upfront'],
    defaultMount: 'Wall',
    priceTitle: 'AC service prices in Abu Dhabi',
    priceIntro: 'Abu Dhabi villas often run six or more units; the per-unit price falls with every unit you add to a visit.',
    servicesTitle: 'AC services in Abu Dhabi',
    servicesIntro: 'Start with the problem you have or the service you want.',
    sections: [
        {
            title: 'Two climates in one city',
            paragraphs: [
                'Abu Dhabi\'s islands and its mainland suburbs are hard on AC units in different ways. On Al Reem, Saadiyat, Yas and along the Corniche, sea humidity keeps coils and drain trays wet, and mould grows quickly - musty smells and blocked drains are the most common complaints.',
                'Inland, in Khalifa City, Mohammed Bin Zayed City and Al Reef, summer temperatures run a few degrees higher and dust is heavier. There, clogged filters, sand-choked outdoor units and tired capacitors cause most breakdowns.',
            ],
        },
        {
            title: 'Villas need a plan, not a call-out',
            tone: 'muted',
            cards: [
                { title: 'Many units, one visit', body: 'A family villa with a majlis, bedrooms and a maid\'s room can have eight or more units. Booking them together costs far less per unit than piecemeal visits.' },
                { title: 'Outdoor units matter', body: 'Condensers on roofs and in side yards bake in the sun and collect sand. An outdoor-unit clean each year keeps the compressor from overheating.' },
                { title: 'Rotate the deep cleans', body: 'Instead of washing every coil in one go, wash two or three units each quarter. The house never loses all its cooling at once.' },
            ],
        },
    ],
    areasIntro: 'We cover Abu Dhabi island, the outer islands and the mainland communities. Each area page notes the homes and AC problems typical there.',
    faqs: [
        {
            question: 'How much does AC service cost in Abu Dhabi?',
            answer: (c) => `A cleaning costs ${c.money(c.tables.general[0].wall)} for one split unit and ${c.money(c.tables.general[4].wall)} for five. A coil chemical wash starts at ${c.money(c.tables.chemicalWash[0].wall)}, and a gas top-up at ${c.money(c.tables.gas.R410A.half)} per outdoor unit.`,
        },
        {
            question: 'Do you cover Yas, Saadiyat and Al Reem?',
            answer: 'Yes, all three, plus the Corniche, Khalidiyah, Mushrif and the mainland communities from Khalifa City to Mohammed Bin Zayed City.',
        },
        {
            question: 'How often should AC be serviced in Abu Dhabi?',
            answer: 'Every three to four months for a cleaning, and a coil chemical wash once a year. Island homes with humidity problems benefit from a coil wash every six months.',
        },
        {
            question: 'Can you service a whole villa in one day?',
            answer: 'Usually yes for cleaning - a two-person visit handles six to eight units in a day. Coil washes on many units are better split across two visits.',
        },
    ],
    serviceType: 'Air conditioner servicing',
    offers: (c) => [
        { name: 'AC cleaning, 1 split unit', price: c.tables.general[0].wall },
        { name: 'AC cleaning, 5 split units', price: c.tables.general[4].wall },
        { name: 'AC cleaning, 1 ducted unit', price: c.tables.general[0].ducted },
        { name: 'Coil chemical wash, 1 split unit', price: c.tables.chemicalWash[0].wall },
        { name: 'Gas top-up R410A, 1 outdoor unit', price: c.tables.gas.R410A.half },
        { name: 'Repair diagnosis visit', price: c.tables.repairDiagnosis },
    ],
}

export default content
